/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './payment-scheme.reducer';

export const PaymentScheme = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const paymentSchemeList = useAppSelector(state => state.paymentScheme.entities);
  const loading = useAppSelector(state => state.paymentScheme.loading);
  const totalItems = useAppSelector(state => state.paymentScheme.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="payment-scheme-heading" data-cy="PaymentSchemeHeading">
        <Translate contentKey="tinyMedicRestApp.paymentScheme.home.title">Payment Schemes</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.paymentScheme.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/payment-scheme/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.paymentScheme.home.createLabel">Create new Payment Scheme</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.paymentScheme.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {paymentSchemeList && paymentSchemeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('addedBy')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.addedBy">Added By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedBy')} />
                </th>
                <th className="hand" onClick={sort('maxDiscountPercentage')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.maxDiscountPercentage">Max Discount Percentage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxDiscountPercentage')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('suspendedReason')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedReason">Suspended Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedReason')} />
                </th>
                <th className="hand" onClick={sort('suspendedDate')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedDate">Suspended Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedDate')} />
                </th>
                <th className="hand" onClick={sort('suspendedBy')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedBy">Suspended By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedBy')} />
                </th>
                <th className="hand" onClick={sort('packageType')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.packageType">Package Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('packageType')} />
                </th>
                <th className="hand" onClick={sort('serviceType')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.serviceType">Service Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serviceType')} />
                </th>
                <th className="hand" onClick={sort('gracePeriod')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.gracePeriod">Grace Period</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gracePeriod')} />
                </th>
                <th className="hand" onClick={sort('remindBefore')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.remindBefore">Remind Before</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remindBefore')} />
                </th>
                <th className="hand" onClick={sort('proposedValue')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.proposedValue">Proposed Value</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('proposedValue')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('pharmacyDiscPercent')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.pharmacyDiscPercent">Pharmacy Disc Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pharmacyDiscPercent')} />
                </th>
                <th className="hand" onClick={sort('maxDiscountAmount')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.maxDiscountAmount">Max Discount Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxDiscountAmount')} />
                </th>
                <th className="hand" onClick={sort('maxCapAmount')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.maxCapAmount">Max Cap Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxCapAmount')} />
                </th>
                <th className="hand" onClick={sort('discPreference')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.discPreference">Disc Preference</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discPreference')} />
                </th>
                <th className="hand" onClick={sort('enforceCap')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.enforceCap">Enforce Cap</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('enforceCap')} />
                </th>
                <th className="hand" onClick={sort('extendedTarrifs')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.extendedTarrifs">Extended Tarrifs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('extendedTarrifs')} />
                </th>
                <th className="hand" onClick={sort('labDiscPercent')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.labDiscPercent">Lab Disc Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('labDiscPercent')} />
                </th>
                <th className="hand" onClick={sort('consDiscPercent')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.consDiscPercent">Cons Disc Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consDiscPercent')} />
                </th>
                <th className="hand" onClick={sort('procedureDiscPercent')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.procedureDiscPercent">Procedure Disc Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureDiscPercent')} />
                </th>
                <th className="hand" onClick={sort('ipDiscPercent')}>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.ipDiscPercent">Ip Disc Percent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ipDiscPercent')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.hospital">Hospital</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paymentScheme.institution">Institution</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {paymentSchemeList.map((paymentScheme, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/payment-scheme/${paymentScheme.id}`} color="link" size="sm">
                      {paymentScheme.id}
                    </Button>
                  </td>
                  <td>{paymentScheme.name}</td>
                  <td>{paymentScheme.startDate}</td>
                  <td>{paymentScheme.endDate}</td>
                  <td>{paymentScheme.addedBy}</td>
                  <td>{paymentScheme.maxDiscountPercentage}</td>
                  <td>{paymentScheme.suspended ? 'true' : 'false'}</td>
                  <td>{paymentScheme.suspendedReason}</td>
                  <td>{paymentScheme.suspendedDate}</td>
                  <td>{paymentScheme.suspendedBy}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PackageType.${paymentScheme.packageType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${paymentScheme.serviceType}`} />
                  </td>
                  <td>{paymentScheme.gracePeriod}</td>
                  <td>{paymentScheme.remindBefore}</td>
                  <td>{paymentScheme.proposedValue}</td>
                  <td>{paymentScheme.active ? 'true' : 'false'}</td>
                  <td>{paymentScheme.cursor}</td>
                  <td>{paymentScheme.lastUpdated}</td>
                  <td>{paymentScheme.microSec}</td>
                  <td>{paymentScheme.timestampEntry}</td>
                  <td>{paymentScheme.pharmacyDiscPercent}</td>
                  <td>{paymentScheme.maxDiscountAmount}</td>
                  <td>{paymentScheme.maxCapAmount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.DiscPref.${paymentScheme.discPreference}`} />
                  </td>
                  <td>{paymentScheme.enforceCap ? 'true' : 'false'}</td>
                  <td>{paymentScheme.extendedTarrifs ? 'true' : 'false'}</td>
                  <td>{paymentScheme.labDiscPercent}</td>
                  <td>{paymentScheme.consDiscPercent}</td>
                  <td>{paymentScheme.procedureDiscPercent}</td>
                  <td>{paymentScheme.ipDiscPercent}</td>
                  <td>
                    {paymentScheme.hospital ? <Link to={`/hospital/${paymentScheme.hospital.id}`}>{paymentScheme.hospital.id}</Link> : ''}
                  </td>
                  <td>
                    {paymentScheme.institution ? (
                      <Link to={`/hospital-institution/${paymentScheme.institution.id}`}>{paymentScheme.institution.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/payment-scheme/${paymentScheme.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/payment-scheme/${paymentScheme.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/payment-scheme/${paymentScheme.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.home.notFound">No Payment Schemes found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={paymentSchemeList && paymentSchemeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PaymentScheme;
